import { render, staticRenderFns } from "./VatCard.vue?vue&type=template&id=2028a67f&scoped=true"
import script from "./VatCard.vue?vue&type=script&lang=js"
export * from "./VatCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028a67f",
  null
  
)

export default component.exports